import React from 'react';
import './Skeleton.scss';

/**
 * Placeholder for a value the server has not supplied yet.
 *
 * Pass the class of the thing being replaced so the skeleton inherits its exact box — a CTA
 * placeholder that is not the size of a CTA just trades a wrong label for a shifting layout.
 *
 * Decorative: it is `aria-hidden` because it says nothing a screen reader can use. Announce the
 * wait on the surrounding region with `aria-busy` where that matters.
 */
export default function Skeleton({ className = '' }: { className?: string }) {
  return <span className={ `skeleton ${className}`.trim() } aria-hidden="true" />;
}
